/* ==========================================================================
   HOME PASSION · hikaye daireleri ve tam ekran oynatici

   Daireler kapak gorseliyle durur. Imlec uzerine gelince YALNIZCA o daire
   oynar (ayni anda 10 video oynatmanin bu magazada tarayiciyi kilitledigi
   olculdu). Tiklayinca tam ekran, 9:16 oynatici acilir; ilerleme cubuklari,
   sag/sol dokunma ile gecis, urun butonu.
   ========================================================================== */
(function(){
  'use strict';
  var RM = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var touch = window.matchMedia('(hover: none)').matches;

  var items = [], idx = 0, viewer = null, vid = null, bars = null, timer = null;

  function build(){
    if(viewer) return;
    viewer = document.createElement('div');
    viewer.className = 'hp-sv';
    viewer.innerHTML =
      '<div class="hp-sv-stage"><div class="hp-sv-box">' +
        '<div class="hp-sv-bars"></div>' +
        '<div class="hp-sv-t"></div>' +
        '<video playsinline muted></video>' +
        '<div class="hp-sv-nav"><button data-p aria-label="Önceki"></button><button data-n aria-label="Sonraki"></button></div>' +
        '<a class="hp-sv-cta" href="#">Ürünü İncele</a>' +
        '<button class="hp-sv-x" aria-label="Kapat"><svg viewBox="0 0 24 24"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '</div></div>';
    document.body.appendChild(viewer);
    vid = viewer.querySelector('video');
    bars = viewer.querySelector('.hp-sv-bars');

    viewer.querySelector('.hp-sv-x').addEventListener('click', close);
    viewer.querySelector('[data-n]').addEventListener('click', function(){ go(idx+1); });
    viewer.querySelector('[data-p]').addEventListener('click', function(){ go(idx-1); });
    viewer.addEventListener('click', function(e){ if(e.target===viewer||e.target.classList.contains('hp-sv-stage')) close(); });
    vid.addEventListener('ended', function(){ go(idx+1); });
    document.addEventListener('keydown', function(e){
      if(!viewer.classList.contains('open')) return;
      if(e.key==='Escape') close();
      if(e.key==='ArrowRight') go(idx+1);
      if(e.key==='ArrowLeft') go(idx-1);
    });
  }

  function go(i){
    if(i < 0) i = 0;
    if(i >= items.length){ close(); return; }
    idx = i;
    var it = items[i];
    vid.src = it.src;
    vid.currentTime = 0;
    var pr = vid.play(); if(pr && pr.catch) pr.catch(function(){});
    viewer.querySelector('.hp-sv-t').textContent = it.label || '';
    var cta = viewer.querySelector('.hp-sv-cta');
    if(it.link){ cta.href = it.link; cta.style.display=''; } else { cta.style.display='none'; }

    bars.innerHTML = '';
    items.forEach(function(_,k){
      var b = document.createElement('i');
      b.innerHTML = '<b style="--p:'+(k<i?1:0)+'"></b>';
      bars.appendChild(b);
    });
    tick();
  }

  function tick(){
    clearInterval(timer);
    timer = setInterval(function(){
      if(!vid.duration) return;
      var b = bars.children[idx];
      if(b) b.firstChild.style.setProperty('--p', (vid.currentTime/vid.duration).toFixed(3));
    }, 100);
  }

  function open(list, i){
    build();
    items = list;
    viewer.classList.add('open');
    document.documentElement.style.overflow = 'hidden';
    go(i);
  }
  function close(){
    if(!viewer) return;
    viewer.classList.remove('open');
    document.documentElement.style.overflow = '';
    clearInterval(timer);
    try{ vid.pause(); vid.removeAttribute('src'); vid.load(); }catch(e){}
  }

  function init(root){
    (root||document).querySelectorAll('.hp-st-row:not([data-init])').forEach(function(row){
      row.dataset.init = '1';
      var cells = [].slice.call(row.querySelectorAll('.hp-st-i'));
      var list = cells.map(function(c){
        return { src:c.dataset.src, label:c.dataset.label, link:c.dataset.link };
      });

      cells.forEach(function(c,i){
        c.addEventListener('click', function(){ open(list, i); });

        if(!touch && !RM){
          c.addEventListener('mouseenter', function(){
            var v = c.querySelector('video');
            if(!v){
              v = document.createElement('video');
              v.muted = true; v.playsInline = true; v.loop = true; v.preload = 'none';
              v.src = c.dataset.src;
              c.appendChild(v);
            }
            c.classList.add('playing');
            var pr = v.play(); if(pr && pr.catch) pr.catch(function(){});
          });
          c.addEventListener('mouseleave', function(){
            var v = c.querySelector('video');
            c.classList.remove('playing');
            if(v){ try{ v.pause(); }catch(e){} }
          });
        }
      });

      var wrap = row.closest('.hp-st');
      if(wrap){
        wrap.querySelectorAll('.hp-st-arw').forEach(function(btn){
          btn.addEventListener('click', function(){
            var to = row.scrollLeft + 88*3*parseInt(btn.dataset.dir,10);
            if(window.hpScrollTo){ window.hpScrollTo(row, to, 380); } else { row.scrollLeft = to; }
          });
        });
      }
    });
  }

  if(document.readyState === 'loading'){ document.addEventListener('DOMContentLoaded', function(){ init(); }); }
  else { init(); }
  document.addEventListener('shopify:section:load', function(e){ init(e.target); });
})();
